import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Badge,
  Container,
  Group,
  Loader,
  Pagination,
  Paper,
  Stack,
  Text,
} from '@mantine/core';
import PageHeader from '@components/shared/PageHeader';
import { useLegacyTableQuery } from '../hooks/queries/useLegacySchemaQuery';
import { LegacyRowsSection } from './components/LegacyUserSections';

const PAGE_SIZE = 50;

export default function AdminLegacyTableBrowser() {
  const { tableName } = useParams();
  const decoded = tableName ? decodeURIComponent(tableName) : null;
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useLegacyTableQuery(
    decoded,
    page,
    PAGE_SIZE
  );

  return (
    <Container size='2xl' py='lg'>
      <Stack gap='lg'>
        <PageHeader
          title={decoded ? `Table: ${decoded}` : 'Legacy table'}
          subtitle='Paginated browse of a vapor table (all columns).'
          breadcrumbs={[
            { label: 'Admin', href: '/admin/users' },
            { label: 'Legacy Migration', href: '/admin/legacy-migration' },
            { label: 'Schema', href: '/admin/legacy-users/schema' },
            { label: decoded ?? 'table' },
          ]}
          backUrl='/admin/legacy-users/schema'
          actions={
            data ? (
              <Badge variant='light'>
                {data.pagination.totalRecords} rows
              </Badge>
            ) : null
          }
        />

        {isLoading ? (
          <Group justify='center' py='xl'>
            <Loader />
          </Group>
        ) : error ? (
          <Text c='red'>{(error as Error).message}</Text>
        ) : !data ? (
          <Text c='dimmed'>No data</Text>
        ) : (
          <Stack gap='md'>
            <Paper withBorder p='md' radius='md'>
              <Text size='sm' c='dimmed' mb='sm'>
                Columns: {data.columns.join(', ')}
              </Text>
              <LegacyRowsSection title={data.table} rows={data.rows} />
              <Group justify='center' mt='md'>
                <Pagination
                  value={page}
                  onChange={setPage}
                  total={data.pagination.totalPages}
                />
              </Group>
            </Paper>
          </Stack>
        )}
      </Stack>
    </Container>
  );
}
